import React from 'react';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { IconSearch } from '@amzn/atoz-web/Icons';
import { useTranslation } from 'react-i18next';
export var FilterFlyoutButton = function (onModalOpen, filterCount) {
    var t = useTranslation().t;
    var innerElement = function (_a) {
        var open = _a.open;
        return (React.createElement(Button, { icon: React.createElement(IconSearch, { "aria-hidden": true }), onClick: function () {
                onModalOpen();
                open();
            }, variant: ButtonVariant.Tertiary, dataTestId: "filter-flyout-button" },
            t('ess_findshifts_filters_button'),
            " (",
            filterCount,
            ")"));
    };
    return innerElement;
};
